/**
 * Utility functions for API interactions
 *//**
 * Handles API responses and performs common checks
 * @param response The fetch API response object
 * @returns The response object if valid
 * @throws Error if the response is not ok
 */export async function handleApiResponse(response){// Check for unauthorized access
if(response.status===401){// Handle authentication errors (e.g., redirect to login)
console.error('Authentication error: User is not authorized');// You might want to redirect to login or clear tokens here
localStorage.removeItem('token');window.location.href='/login';throw new Error('Authentication error: User is not authorized');}// Handle other common error cases
if(!response.ok){const errorText=await response.text();console.error(`API Error (${response.status}): ${errorText}`);throw new Error(`API Error: ${response.status} - ${errorText}`);}return response;}/**
 * Creates headers with authentication token
 * @returns Headers object with Authorization token
 */export function getAuthHeaders(){const token=localStorage.getItem('token');return{'Content-Type':'application/json','Authorization':token?`Bearer ${token}`:''};}